import React, { Component } from 'react';
import OptionButtonEvent from './OptionButtonEvent';
import TitleSectionEvent from './TitleSectionEvent';
import SetLangsLive from './SetLangsLive';
import PlayerAudioSubtitleHelper from '../../../AAFPlayer/helpers/PlayerAudioSubtitleHelper';
import DeviceStorage from '../../DeviceStorage/DeviceStorage';
import * as EventOptionsUtils from '../EventOptionsUtils';
import Asset from '../../../requests/apa/Asset';
import Translator from '../../../requests/apa/Translator';
import TvChannelUtil from '../../../utils/TvChannelUtil';
import * as constant from '../../../AAFPlayer/constants'
import MultipleLangLive from '../../../AAF/LanguageLive/MultipleLangLive';
import Device from '../../../devices/device';
import logger from 'src/utils/logger/logger';

class LangLiveEvent extends Component {
    constructor(props = {}) {
        super(props);
        this.activeLang = DeviceStorage.getItem('default_lang_audio_live') || false;
        this.activeSubtitle = DeviceStorage.getItem('default_lang_subtitle_live') || false;
        this.audioSubs = PlayerAudioSubtitleHelper.getAndroidAudioSubtitleLive(SetLangsLive.get());
        this.ottAudioTracks = []
        this.ottSubtitlesTracks = []
        this.isEnabled = EventOptionsUtils.isMAEnabled(this.props.data, this.props.streamType, this.props.streamContentType);
        this.imageButton_language = Asset.get('playingLive_channel_option_button_changeLanguaje', '/images/ic_subtitle.png');
        this.titleAudio = Translator.get('panelOptions_sidemenu_subtitle_audio_label','AUDIO');
        this.titleSubtitle = Translator.get('panelOptions_sidemenu_subtitle_subtitules_label','SUBTÍTULOS');
        this.titlePrincipal = Translator.get('panelOptions_sidemenu_item_channel_button_changeLanguage','Cambiar Idioma del canal');
        this.subtitlePrincipal = Translator.get('panelOptions_sidemenu_title_changeLanguage_label','Elegir el idioma del canal');
        this.items = [];
    }

    getLangOptions = (langs) => {
        const isActiveLangEnabled = langs.find((lang) => lang.option_id === this.activeLang);
        return langs.map((lang, index) => {
            const { label_large = '', option_id = '' } = lang;
            const active = isActiveLangEnabled ? this.activeLang === option_id : index === 0;
            const imageAud = Asset.get('playingLive_changeLanguage_option_button_audio', '/images/ic_audio.png');
            return {
                item: (
                    <OptionButtonEvent
                        title={label_large}
                        onClick={() => {
                            this.changeLang(lang);
                        }}
                        active={active}
                        image={imageAud}
                    />
                ),
            };
        });
    };

    changeLang = (langCode) => {
        if(langCode && langCode.label_large){
            this.props && (typeof this.props.sendMetric === 'function') && this.props.sendMetric(`cambiar idioma / ${langCode.label_large}`, 'idioma');
        }
        if(this.activeLang === langCode.option_id) return;
        this.activeLang = langCode.option_id;
        if((typeof this.props.changeLang === 'function')){
            this.props.changeLang(langCode);
            this.realoadData();
            // https://dlatvarg.atlassian.net/browse/STV-12039
            // (typeof this.props.handleClose === 'function') && this.props.handleClose();
        }
    };

    changeSubtitle = (subtitle) => {
        if(this.activeSubtitle === subtitle.option_id) return;
        if(subtitle && subtitle.label_large){
            this.props && (typeof this.props.sendMetric === 'function') && this.props.sendMetric(`cambiar idioma / ${subtitle.label_large}`, 'idioma');
        }
        this.activeSubtitle =  subtitle.option_id;
        if((typeof this.props.changeLang === 'function')){
            this.props.changeLang(subtitle);
            this.realoadData();
            // https://dlatvarg.atlassian.net/browse/STV-12039
            // (typeof this.props.handleClose === 'function') && this.props.handleClose();
        }
    };

    realoadData = () => {
        this.items = this.getData();
        this.props.onClick(this.items, false);
    }

    getSubtitleOptions = (subtitles) => {
        return subtitles.map((subtitle) => {
            const { label_large = '', option_id = '' } = subtitle;
            const active = this.activeSubtitle === option_id;
            const imageSub = Asset.get('playingLive_changeLanguage_option_button_subtitule', '/images/ic_subtitle.png');
            return {
                item: (
                    <OptionButtonEvent
                        title={label_large}
                        onClick={() => {
                            this.changeSubtitle(subtitle);
                        }}
                        active={active}
                        image = {imageSub}
                    />
                ),
            };
        });
    };

    async componentDidMount() {
        await this.getAudioTracks();
        this.items = this.getData();
        if(this.props && this.props.keyFrom && this.props.keyFrom === 'SUB_AUD'){
            (typeof this.props.onClick === 'function') && this.props.onClick(this.items);
        }
    }

    async getAudioTracks() {
        const playerInstance = Device.getDevice().getPlayer();
        const audioTracks = await playerInstance.getAudioTracks();
        const platform = Device.getDevice().getPlatform();

        // Valida si el contenido cuenta con más de un audioTrack
        if (audioTracks.length < 2) {
            this.ottAudioTracks = [];
        } else {
            // Detecta el tipo de dispositivo y homologa la estructura de los audioTracks
            switch (platform) {
                case 'samsung':
                    for (let i = 0; i < audioTracks.length; i++) {
                        const audioLabel = `button_live_audio_${audioTracks[i]}`;
                        this.ottAudioTracks.push({
                            option_id: audioTracks[i],
                            label_large: Translator.get(audioLabel, MultipleLangLive.nameTagTemp(audioLabel)),
                            track: audioTracks[i],
                            isAudio: true,
                        })
                    }
                    break;
                case 'ps4':
                    for (let i = 0; i < audioTracks.length; i++) {
                        const audioLabel = `button_live_audio_${audioTracks[i]}`;
                        this.ottAudioTracks.push({
                            option_id: audioTracks[i],
                            label_large: Translator.get(audioLabel, MultipleLangLive.nameTagTemp(audioLabel)),
                            track: audioTracks[i],
                            isAudio: true,
                        })
                    }
                    break;
                case 'tizen':
                    for (let i = 0; i < audioTracks.length; i++) {
                        const audioLabel = `button_live_audio_${audioTracks[i].lang}`;
                        this.ottAudioTracks.push({
                            option_id: audioTracks[i].lang,
                            label_large: Translator.get(audioLabel, MultipleLangLive.nameTagTemp(audioLabel)),
                            track: audioTracks[i].lang,
                            isAudio: true,
                        })
                    }
                    break;
                default:
                    for (let i = 0; i < audioTracks.length; i++) {
                        const audioLabel = `button_live_audio_${audioTracks[i].language}`;
                        this.ottAudioTracks.push({
                            option_id: audioTracks[i].language,
                            label_large: Translator.get(audioLabel, MultipleLangLive.nameTagTemp(audioLabel)),
                            track: audioTracks[i].language,
                            isAudio: true,
                        })
                    }
                    break;
            }
            logger.debug("[LangLiveEvent / getAudioTracks] - playerInstance:", playerInstance);
            logger.debug("[LangLiveEvent / getAudioTracks] - audioTracks:", audioTracks);
            logger.debug("[LangLiveEvent / getAudioTracks] - ottAudioTracks:", this.ottAudioTracks);
        }
    }

    getData = () => {
        logger.debug("[LangLiveEvent / getData] - ottAudioTracks:", this.ottAudioTracks);
        logger.debug("[LangLiveEvent / getData] - ottAudioTracks.length:", this.ottAudioTracks.length);

        const langs = this.audioSubs && this.audioSubs.audio && Array.isArray(this.audioSubs.audio) && this.audioSubs.audio.length > 0 ? this.audioSubs.audio : this.ottAudioTracks;
        const subtitles = this.audioSubs && this.audioSubs.subtitles && Array.isArray(this.audioSubs.subtitles) && this.audioSubs.subtitles.length > 0 ? this.audioSubs.subtitles : this.ottSubtitlesTracks;

        logger.debug("[LangLiveEvent / getData] - langs", langs);
        logger.debug("[LangLiveEvent / getData] - langs.lenght", langs.length);

        if(!this.isEnabled || (this.isEnabled && langs.length === 0 && subtitles.length === 0)){
            return [
                {
                    item: <TitleSectionEvent title={this.subtitlePrincipal} className={'event_option_title_section_main_title'}/>,
                },
                {
                    item: <TitleSectionEvent title={this.titleAudio} />
                },
                {
                    item: <OptionButtonEvent
                    title={Translator.get('panelOptions_sidemenu_option_default_label','Idioma Original')}
                    active={true}
                    image = {Asset.get('playingLive_changeLanguage_option_button_audio', '/images/ic_subtitle.png')}
                />
                }
            ];
        }else{
            return [
                {
                 item: <TitleSectionEvent title={this.subtitlePrincipal} className={'event_option_title_section_main_title'}/>,
                },
                {
                    item: langs.length > 0 ? <TitleSectionEvent title={this.titleAudio} />: null,
                },
                ...this.getLangOptions(langs),
                {
                    item: subtitles.length > 0 ? <TitleSectionEvent title={this.titleSubtitle} />: null,
                },
                ...this.getSubtitleOptions(subtitles),
            ];
        }

    }

    componentWillMount() {}

    render() {
        const currentGroupId = TvChannelUtil.getLastChannel();
        const {group_id = false} = this.props && this.props.data || {};

        return (
            (currentGroupId !== group_id && (this.props && this.props.streamContentType !== constant.AAF_CONTENT_IS_NPVR)) ? null:
            <OptionButtonEvent
                title={this.titlePrincipal}
                onClick={() => {
                    this.props && (typeof this.props.sendMetric === 'function') && this.props.sendMetric('cambiar idioma del canal');
                    this.props.onClick(this.items)
                }}
                image={this.imageButton_language}
            />
        );
    }
}

export default LangLiveEvent;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/LangLiveEvent.jsx